import { render, staticRenderFns } from "./jjtx.vue?vue&type=template&id=1b334fdf&scoped=true&"
import script from "./jjtx.vue?vue&type=script&lang=js&"
export * from "./jjtx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b334fdf",
  null
  
)

export default component.exports